
const customercreditBackdrop        = require('./customercredit-backdrop')
const customercreditConfirmation    = require('./customercredit-confirmation')
const customercreditDialog          = require('./customercredit-dialog')
const customercreditDt              = require('./customercredit-dt')
const customercreditFullcont        = require('./customercredit-fullcont')
const customercreditMenu            = require('./customercredit-menu')
const customercreditPage            = require('./customercredit-page')
const customercreditSnack           = require('./customercredit-snack')
const customercreditMT              = require('./customercredit-fullcont-multitable')




export function start(detail){  

         
      obj[detail.elem].start(detail)

}/**/




const obj = {
   
      backdrop:        { start: (detail)=>{  customercreditBackdrop.start(detail)         }},
      confirmation:    { start: (detail)=>{  customercreditConfirmation.start(detail)     }},
      dialog:          { start: (detail)=>{  customercreditDialog.start(detail)           }},
      dt:              { start: (detail)=>{  customercreditDt. start(detail)              }},
      fullcont:        { start: (detail)=>{  customercreditFullcont.start(detail)        }},
      multitable:      { start: (detail)=>{  customercreditMT.start(detail)               }},
      menu:            { start: (detail)=>{  customercreditMenu.start(detail)             }},
      page:            { start: (detail)=>{  customercreditPage.start(detail)             }},
      snack:           { start: (detail)=>{  customercreditSnack.start(detail)            }},

}